export default __webpack_public_path__ + "c84c0b5078b108890d87cb8c5d8829f9.png";